"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));

var _ProductDetailContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductDetailContext"));

var _de = _interopRequireDefault(require("../../../../locals/de.json"));

var _en = _interopRequireDefault(require("../../../../locals/en.json"));

var _it = _interopRequireDefault(require("../../../../locals/it.json"));

var _Select2 = _interopRequireDefault(require("./Select.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Select = function Select(_ref) {
  var identifier = _ref.identifier,
      label = _ref.label,
      lang = _ref.lang,
      options = _ref.options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value;

  var _useContext = (0, _react.useContext)(_ProductDetailContext.default),
      attributes = _useContext.attributes,
      combinationValues = _useContext.combinationValues,
      setCombinationValues = _useContext.setCombinationValues;

  var css = (0, _Select2.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  var checkIfSelectable = (0, _react.useCallback)(function (value) {
    var _options$find;

    return options === null || options === void 0 ? void 0 : (_options$find = options.find(function (_ref2) {
      var id = _ref2.id;
      return id === value;
    })) === null || _options$find === void 0 ? void 0 : _options$find.selectable;
  }, [options]);

  var handleChange = function handleChange(identifier, value) {
    var _combinationValues = _objectSpread({}, combinationValues);

    if (!checkIfSelectable(value)) {
      for (var _i = 0, _Object$keys = Object.keys(attributes); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        delete _combinationValues[key];
      }
    }

    delete _combinationValues.combinationID;
    _combinationValues[identifier] = value;
    setCombinationValues(_combinationValues);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.select, "mco-shop-combination-selection__select")
  }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, null, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  })), /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: !value,
    label: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    }),
    name: identifier,
    value: value,
    MenuProps: {
      classes: {
        paper: css.menuPaper
      },
      disableScrollLock: true
    },
    onChange: function onChange(e) {
      return handleChange(identifier, e.target.value);
    }
  }, options === null || options === void 0 ? void 0 : options.map(function (option, index) {
    var id = option.id,
        _option$selectable = option.selectable,
        selectable = _option$selectable === void 0 ? true : _option$selectable,
        title = option.title;
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      className: (0, _clsx2.default)(_defineProperty({}, css.disabled, !selectable)),
      key: index,
      value: id
    }, title);
  }))), !value && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx2.default)(css.errorMessage, "mco-shop-combination-selection__error-message")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.productDetail.messages.errors.select",
    l: l,
    label: label
  })));
};

var _default = Select;
exports.default = _default;